import {CopyButton, MenuItem} from "@dv5/components"
import {PartType} from '@dv5/domain'
import React, {FC} from "react"
import './PartHeaderInfo.less'

interface PartHeaderInfoProps {
    header: string | null
    type: string
    onCopy: (itemId?: string) => void | Promise<void>
}

const defaultMenuItems: MenuItem[] = [
    { id: 'copy', title: 'Copy with header' },
    { id: 'copy-without-header', title: 'Copy without header' },
    { id: 'copy-source', title: 'Copy source' },
]

const csvMenuItems: MenuItem[] = [
    { id: 'copy-source', title: 'Copy source' },
    { id: 'export-csv', title: 'Export to CSV file' },
]

const menuItemsByType: Record<PartType, MenuItem[]> = {
    [PartType.MARKDOWN]: defaultMenuItems,
    [PartType.PLAINTEXT]: defaultMenuItems,
    [PartType.CSV_TABLE]: csvMenuItems,
    [PartType.DIARY]: defaultMenuItems,
    [PartType.SECRET]: defaultMenuItems,
}

export const PartHeaderInfo: FC<PartHeaderInfoProps> = ({ header, type, onCopy }) => {
    const menuItems = menuItemsByType[type as PartType] || defaultMenuItems

    return (
        <div className="part-header-info">
            <span className="part-header">{header || 'No Header'}</span>
            <CopyButton
                onCopy={onCopy}
                menuItems={menuItems}
            />
            <span className="part-type">[{type}]</span>
        </div>
    )
}
